import { Suspense, useEffect } from 'react';

import StatsWidgetsContainer from '@/features/vehicle-status/StatsWidgetsContainer';
import VehicleDataTabsContainer from '@/features/vehicle-status/VehicleDataTabsContainer';
import { isAssetTreeSelected } from '@/utils/commonUtils';
import { LoadingIndicator } from './LoadingIndicator';
import { REQUEST_ASSET_TREE_SELECTION, sendMessage } from './MessageHandler';

const requestAssetTreeSelection = () => {
    sendMessage({
        type: REQUEST_ASSET_TREE_SELECTION,
        payload: {},
    });
};

const MainComponent = () => {
    useEffect(() => {
        if (isAssetTreeSelected()) {
            requestAssetTreeSelection();
        }
    }, []);
    return (
        <div
            className="overflow-hidden display-flex flex-column padding-20"
            style={{ backgroundColor: '#FFFFFF' }}
            data-testid="main-component"
        >
            <Suspense fallback={<LoadingIndicator />}>
                <StatsWidgetsContainer />
                <VehicleDataTabsContainer />
            </Suspense>
        </div>
    );
};

export default MainComponent;
